import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { GetAlcoValueRequest, GetAlcoValueResponse, PostAlcoRequest } from '../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';

@Component({
  templateUrl: 'alcometer-value.component.html',
  styleUrls: ['./alcometer-value.component.scss']
})
export class AlcometerValueComponent implements OnInit {

  alcoValue: number = 0;
  loading: boolean = true;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loadAlcometer();
  }

  loadAlcometer() {
    this.loading = true;
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher() || this.activeUserLocalDataService.activeServiceVoucher;
    if (activeVoucher) {
      const request: GetAlcoValueRequest = { voucherId: activeVoucher.id };
      this.courierService.getAlcoValue(request).subscribe((response: GetAlcoValueResponse) => {
        if (response.alcoValue != null) {
          this.alcoValue = response.alcoValue;
        }
        this.loading = false;
      }, error => {
        console.error('Error fetching alco value:', error);
        this.loading = false;
      });
    } else {
      console.error('Active voucher is null');
      this.navigateToVoucher();
      this.loading = false;
    }
  }

  navigateToVoucher() {
    const serviceVoucher = this.activeUserLocalDataService.activeServiceVoucher;
    const courierVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();

    if (serviceVoucher) {
      this.router.navigate(['/service-voucher']);
    } else if (courierVoucher) {
      this.router.navigate(['/voucher']);
    } else {
      this.router.navigate(['/voucher']);
    }
  }

  saveClick() {
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher() || this.activeUserLocalDataService.activeServiceVoucher;
    if (!activeVoucher) {
      this.navigateToVoucher();
      return;
    }

    const request: PostAlcoRequest = {
      alcoValue: this.alcoValue,
      voucherId: activeVoucher.id,
    };

    this.courierService.postAlco(request).subscribe(() => {
      this.navigateToVoucher();
    });
  }
}